/**
 * Maps PA interested curriculums to PDL preferred publication payloads for bulk converter.
 * Joins interested rows with the full curriculum catalog to read pdlCurriculumId / pdlAdoptYear.
 */
import { keyBy } from 'lodash'

export const mapInterestedCurriculumsToPreferredStandardPublications = (
  interestedCurriculums = [],
  allCurriculums = []
) => {
  if (!Array.isArray(interestedCurriculums) || !interestedCurriculums.length) {
    return []
  }
  if (!Array.isArray(allCurriculums)) {
    return []
  }
  const byId = keyBy(allCurriculums, '_id')

  const preferred = []
  interestedCurriculums.forEach((interested) => {
    const curriculum = byId[interested?._id]
    if (!curriculum) {
      return
    }
    const publicationId = Number(curriculum?.pdlCurriculumId)
    if (!publicationId || Number.isNaN(publicationId)) {
      return
    }
    const year = curriculum?.pdlAdoptYear
      ? String(curriculum.pdlAdoptYear)
      : /\((\d{4})\)/.exec(curriculum.curriculum)?.[1] || undefined

    const alreadyAdded = preferred.some(
      (item) =>
        item.publication_id === publicationId &&
        (item.year ?? '') === (year ?? '')
    )
    if (alreadyAdded) {
      return
    }
    preferred.push(
      year
        ? { publication_id: publicationId, year }
        : { publication_id: publicationId }
    )
  })
  return preferred
}
